export type Locale = "de" | "en" | "es" | "fr";

const deMessages = {
    bookAppointment: "Termin buchen",
    stepService: "Leistung",
    stepStaff: "Mitarbeiter",
    stepTime: "Zeit",
    stepContact: "Kontakt",
    chooseService: "Wähle eine Leistung",
    chooseStaff: "Wähle einen Mitarbeiter",
    noPreference: "Egal wer",
    chooseDay: "Tag wählen",
    chooseSlot: "Uhrzeit wählen",
    noSlots: "Keine freien Termine an diesem Tag.",
    yourDetails: "Deine Kontaktdaten",
    name: "Name",
    phone: "Telefon (optional)",
    email: "E-Mail (optional)",
    emailHint: "Für die Bestätigungs-E-Mail mit Storno-Link",
    note: "Anmerkung (optional)",
    createAccount: "Konto erstellen und mit dieser Werkstatt verbinden",
    password: "Passwort",
    confirmBooking: "Termin buchen",
    back: "Zurück",
    continue: "Weiter",
    loading: "Laden…",
    booking: "Wird gebucht…",
    successTitle: "Termin bestätigt!",
    successBody: "Dein Termin wurde erfolgreich gebucht.",
    successEmail: "Du erhältst eine Bestätigungs-E-Mail mit einem Storno-Link.",
    salonNotFound: "Werkstatt nicht gefunden. Bitte prüfe den Link.",
    errorGeneric: "Etwas ist schiefgelaufen. Bitte versuche es erneut.",
    cancelTitle: "Termin stornieren",
    cancelConfirm: "Termin jetzt stornieren",
    cancelSuccess: "Dein Termin wurde storniert.",
    cancelAlready: "Dieser Termin wurde bereits storniert.",
    cancelInvalid: "Storno-Link ungültig oder abgelaufen.",
    cancelTooLate: "Storno ist zu diesem Zeitpunkt nicht mehr möglich.",
    poweredBy: "Buchung über",
    duration: "Dauer",
    minutes: "Min.",
    required: "Pflichtfeld",
    invalidEmail: "Ungültige E-Mail-Adresse",
    passwordMin: "Mindestens 10 Zeichen, Groß- und Kleinbuchstabe sowie eine Ziffer",
    passwordTooWeak: "Bitte wähle ein stärkeres Passwort (mind. 10 Zeichen, Groß-/Kleinbuchstabe, Ziffer).",
    orderTitle: "Auftrag",
    orderEmail: "E-Mail oder Benutzername",
    orderEmailPrompt: "Bitte gib deine E-Mail-Adresse oder deinen Benutzernamen ein",
    orderEmailHint: "Muss mit der beim Auftrag hinterlegten E-Mail oder dem Benutzernamen übereinstimmen.",
    orderView: "Auftrag anzeigen",
    orderAccessDenied: "Code oder E-Mail/Benutzername ist ungültig.",
    orderStatus: "Status",
    orderItems: "Positionen",
    orderTotal: "Gesamt",
    orderNote: "Hinweis",
    orderPickupScheduled: "Abholtermin",
    orderSchedulePickup: "Abholtermin vereinbaren",
    orderPickupSuccessTitle: "Abholtermin bestätigt!",
    orderPickupSuccessBody: "Dein Abholtermin wurde erfolgreich gebucht.",
    orderConfirmPickup: "Abholtermin buchen",
    orderDropoffScheduled: "Abgabetermin",
    orderScheduleDropoff: "Abgabetermin vereinbaren",
    orderRescheduleDropoff: "Abgabetermin ändern",
    orderCancelDropoff: "Abgabetermin stornieren",
    orderConfirmDropoff: "Abgabetermin buchen",
    orderDropoffSuccessTitle: "Abgabetermin bestätigt!",
    orderDropoffSuccessBody: "Dein Abgabetermin wurde erfolgreich gebucht.",
    orderDropoffCanceled: "Abgabetermin storniert.",
    orderInquiries: "Rückfragen",
    orderInquiryHint: "Antworte der Werkstatt…",
    orderInquiryAnswer: "Antwort senden",
    orderInquirySent: "Antwort gesendet.",
    orderInquiryStaff: "Werkstatt",
    orderInquiryCustomer: "Du",
    phaseReceived: "Angenommen",
    phaseQuote: "Angebot",
    phaseInProgress: "In Arbeit",
    phaseReady: "Abholbereit",
    phaseDone: "Abgeholt",
    orderCustomerPhotosNotes: "Deine Fotos & Notizen",
    orderCustomerAddPhoto: "Foto hinzufügen",
    orderCustomerAddNote: "Notiz hinzufügen",
    orderCustomerNoteHint: "Problem beschreiben oder Details für die Werkstatt…",
    orderCustomerNotes: "Deine Notizen",
    orderCustomerPhotos: "Deine Fotos",
    orderCustomerNoteAdded: "Notiz hinzugefügt",
    orderCustomerPhotoAdded: "Foto hinzugefügt",
    orderUploading: "Wird hochgeladen…",
    rrTitle: "Reparatur-Anfrage",
    rrStepObject: "Objekt",
    rrStepDetails: "Details",
    rrStepContact: "Kontakt",
    rrStepDropoff: "Abgabe",
    rrStepServices: "Services",
    rrStepRepairDay: "Reparatur-Tag",
    rrStepReview: "Prüfen",
    rrPickServices: "Service-Produkte wählen",
    rrPickServicesHint: "Wähle ein oder mehrere Angebote.",
    rrPricesExcludeParts: "Preise ohne Material und Teile.",
    rrUncategorized: "Ohne Kategorie",
    rrPickRepairDay: "Reparatur-Tag wählen",
    rrNoCapacityDays: "In den nächsten Wochen ist kein passender Tag frei.",
    rrDropoffChoice: "Wann möchtest du abgeben?",
    rrDropoffHintTitle: "Bitte abgeben",
    rrDropoffHintBody: "Gib dein Werkstück / Fahrzeug am {date} zwischen {from} und {to} Uhr ab.",
    rrDropoffDayBeforeChoice: "Abend vorher, {date}, {from}–{to} Uhr",
    rrDropoffSameDayChoice: "Am Reparatur-Tag, {date}, {from}–{to} Uhr",
    rrSelectedServices: "Gewählte Services",
    rrObjectHeading: "Um welches Objekt geht es?",
    rrObjectPreview: "Vorschau",
    rrDetailsHeading: "Was ist zu reparieren?",
    rrDescription: "Beschreibung (optional)",
    rrDescriptionHint: "Beschreibe den Schaden oder das Problem so genau wie möglich.",
    rrPhotos: "Fotos (optional)",
    rrPhotosHint: "z.B. Fotos des Objekts, des Schadens oder Fahrzeugscheins",
    rrAddressSearch: "Adresse suchen",
    rrAddressSearchHint: "Straße, PLZ oder Ort eingeben",
    rrAddressNotFound: "Keine Adresse gefunden.",
    rrAddPhoto: "Foto hinzufügen",
    rrRemovePhoto: "Entfernen",
    rrContactHeading: "Deine Kontaktdaten",
    rrFirstName: "Vorname",
    rrLastName: "Nachname",
    rrEmailRequired: "E-Mail",
    rrPhoneRequired: "Telefon",
    rrStreet: "Straße",
    rrPostalCode: "PLZ",
    rrCity: "Ort",
    rrAddressOptional: "Adresse (optional)",
    rrInvalidPhone: "Ungültige Telefonnummer",
    rrDropoffHeading: "Abgabetermin wählen",
    rrDropoffHint: "Wähle einen Termin, an dem du das Objekt vorbeibringst.",
    rrDropoffSkip: "Später vereinbaren",
    rrDropoffSelected: "Gewählter Abgabetermin",
    rrDropoffRequired: "Bitte wähle einen Abgabetermin.",
    rrReviewHeading: "Zusammenfassung",
    rrSubmit: "Anfrage absenden",
    rrSubmitting: "Wird gesendet…",
    rrSuccessTitle: "Anfrage eingegangen!",
    rrSuccessBody: "Deine Reparatur-Anfrage wurde übermittelt.",
    rrSuccessEmail: "Du erhältst eine Bestätigungs-E-Mail.",
    rrOrderNumber: "Anfragenummer",
    rrDownloadApp: "Werkstate App laden",
    rrDownloadAppHint: "Status verfolgen und Mitteilungen erhalten – am besten in der App.",
    rrUnavailable: "Reparatur-Anfragen sind für diese Werkstatt derzeit nicht verfügbar.",
    rrPoweredBy: "Anfrage über",
    legalNavLabel: "Rechtliches",
    legalPrivacy: "Datenschutz",
    legalTerms: "AGB",
    legalImprint: "Impressum",
    consentPrefix: "Ich akzeptiere die ",
    consentPrivacyLink: "Datenschutzerklärung",
    consentAnd: " und ",
    consentTermsLink: "AGB",
    consentRequired: "Bitte akzeptiere die Datenschutzerklärung und AGB.",
};

const enMessages = {
    bookAppointment: "Book appointment",
    stepService: "Service",
    stepStaff: "Staff",
    stepTime: "Time",
    stepContact: "Contact",
    chooseService: "Choose a service",
    chooseStaff: "Choose a staff member",
    noPreference: "No preference",
    chooseDay: "Choose a day",
    chooseSlot: "Choose a time",
    noSlots: "No available slots on this day.",
    yourDetails: "Your contact details",
    name: "Name",
    phone: "Phone (optional)",
    email: "Email (optional)",
    emailHint: "For confirmation email with cancellation link",
    note: "Note (optional)",
    createAccount: "Create account and connect to this workshop",
    password: "Password",
    confirmBooking: "Book appointment",
    back: "Back",
    continue: "Continue",
    loading: "Loading…",
    booking: "Booking…",
    successTitle: "Appointment confirmed!",
    successBody: "Your appointment has been booked successfully.",
    successEmail: "You will receive a confirmation email with a cancellation link.",
    salonNotFound: "Workshop not found. Please check the link.",
    errorGeneric: "Something went wrong. Please try again.",
    cancelTitle: "Cancel appointment",
    cancelConfirm: "Cancel appointment now",
    cancelSuccess: "Your appointment has been canceled.",
    cancelAlready: "This appointment was already canceled.",
    cancelInvalid: "Cancellation link is invalid or expired.",
    cancelTooLate: "Cancellation is no longer possible at this time.",
    poweredBy: "Booking via",
    duration: "Duration",
    minutes: "min",
    required: "Required",
    invalidEmail: "Invalid email address",
    passwordMin: "At least 10 characters, with upper and lower case and a number",
    passwordTooWeak: "Please choose a stronger password (min. 10 characters, upper/lower case, digit).",
    orderTitle: "Order",
    orderEmail: "Email or username",
    orderEmailPrompt: "Please enter your email address or username",
    orderEmailHint: "Must match the email or username stored for this order.",
    orderView: "View order",
    orderAccessDenied: "Invalid code or email/username.",
    orderStatus: "Status",
    orderItems: "Items",
    orderTotal: "Total",
    orderNote: "Note",
    orderPickupScheduled: "Pickup appointment",
    orderSchedulePickup: "Schedule pickup",
    orderPickupSuccessTitle: "Pickup confirmed!",
    orderPickupSuccessBody: "Your pickup appointment has been booked successfully.",
    orderConfirmPickup: "Book pickup",
    orderDropoffScheduled: "Drop-off appointment",
    orderScheduleDropoff: "Schedule drop-off",
    orderRescheduleDropoff: "Reschedule drop-off",
    orderCancelDropoff: "Cancel drop-off",
    orderConfirmDropoff: "Book drop-off",
    orderDropoffSuccessTitle: "Drop-off confirmed!",
    orderDropoffSuccessBody: "Your drop-off appointment has been booked successfully.",
    orderDropoffCanceled: "Drop-off appointment canceled.",
    orderInquiries: "Questions",
    orderInquiryHint: "Reply to the workshop…",
    orderInquiryAnswer: "Send reply",
    orderInquirySent: "Reply sent.",
    orderInquiryStaff: "Workshop",
    orderInquiryCustomer: "You",
    phaseReceived: "Received",
    phaseQuote: "Quote",
    phaseInProgress: "In progress",
    phaseReady: "Ready for pickup",
    phaseDone: "Picked up",
    orderCustomerPhotosNotes: "Your photos & notes",
    orderCustomerAddPhoto: "Add photo",
    orderCustomerAddNote: "Add note",
    orderCustomerNoteHint: "Describe the issue or add details for the workshop…",
    orderCustomerNotes: "Your notes",
    orderCustomerPhotos: "Your photos",
    orderCustomerNoteAdded: "Note added",
    orderCustomerPhotoAdded: "Photo added",
    orderUploading: "Uploading…",
    rrTitle: "Repair request",
    rrStepObject: "Object",
    rrStepDetails: "Details",
    rrStepContact: "Contact",
    rrStepDropoff: "Drop-off",
    rrStepServices: "Services",
    rrStepRepairDay: "Repair day",
    rrStepReview: "Review",
    rrPickServices: "Choose service products",
    rrPickServicesHint: "Pick one or more offerings.",
    rrPricesExcludeParts: "Prices are without materials or parts.",
    rrUncategorized: "Uncategorized",
    rrPickRepairDay: "Choose a repair day",
    rrNoCapacityDays: "No matching day is free in the coming weeks.",
    rrDropoffChoice: "When would you like to drop it off?",
    rrDropoffHintTitle: "Please drop off",
    rrDropoffHintBody: "Please drop off your item / vehicle on {date} between {from} and {to}.",
    rrDropoffDayBeforeChoice: "Evening before, {date}, {from}–{to}",
    rrDropoffSameDayChoice: "On the repair day, {date}, {from}–{to}",
    rrSelectedServices: "Selected services",
    rrObjectHeading: "What needs repair?",
    rrObjectPreview: "Preview",
    rrDetailsHeading: "What should be repaired?",
    rrDescription: "Description (optional)",
    rrDescriptionHint: "Describe the damage or issue as clearly as possible.",
    rrPhotos: "Photos (optional)",
    rrPhotosHint: "e.g. photos of the object, the damage, or the vehicle registration",
    rrAddressSearch: "Search address",
    rrAddressSearchHint: "Enter street, postal code, or city",
    rrAddressNotFound: "No address found.",
    rrAddPhoto: "Add photo",
    rrRemovePhoto: "Remove",
    rrContactHeading: "Your contact details",
    rrFirstName: "First name",
    rrLastName: "Last name",
    rrEmailRequired: "Email",
    rrPhoneRequired: "Phone",
    rrStreet: "Street",
    rrPostalCode: "Postal code",
    rrCity: "City",
    rrAddressOptional: "Address (optional)",
    rrInvalidPhone: "Invalid phone number",
    rrDropoffHeading: "Choose a drop-off time",
    rrDropoffHint: "Choose when you will bring the item to the workshop.",
    rrDropoffSkip: "Schedule later",
    rrDropoffSelected: "Selected drop-off time",
    rrDropoffRequired: "Please choose a drop-off time.",
    rrReviewHeading: "Summary",
    rrSubmit: "Submit request",
    rrSubmitting: "Submitting…",
    rrSuccessTitle: "Request received!",
    rrSuccessBody: "Your repair request has been submitted.",
    rrSuccessEmail: "You will receive a confirmation email.",
    rrOrderNumber: "Request number",
    rrDownloadApp: "Get the Werkstate app",
    rrDownloadAppHint: "Track status and get notifications — best in the app.",
    rrUnavailable: "Repair requests are currently unavailable for this workshop.",
    rrPoweredBy: "Request via",
    legalNavLabel: "Legal",
    legalPrivacy: "Privacy",
    legalTerms: "Terms",
    legalImprint: "Imprint",
    consentPrefix: "I accept the ",
    consentPrivacyLink: "Privacy Policy",
    consentAnd: " and ",
    consentTermsLink: "Terms",
    consentRequired: "Please accept the Privacy Policy and Terms.",
};

const messages = {
  de: deMessages,
  en: enMessages,
  es: {
    ...enMessages,
    bookAppointment: "Reservar cita",
    stepService: "Servicio",
    stepStaff: "Empleado",
    stepTime: "Hora",
    stepContact: "Contacto",
    chooseService: "Elige un servicio",
    chooseStaff: "Elige un empleado",
    noPreference: "Sin preferencia",
    chooseDay: "Elige un día",
    chooseSlot: "Elige una hora",
    noSlots: "No hay horarios disponibles este día.",
    yourDetails: "Tus datos de contacto",
    name: "Nombre",
    phone: "Teléfono (opcional)",
    email: "Correo (opcional)",
    emailHint: "Para el correo de confirmación con enlace de cancelación",
    note: "Nota (opcional)",
    createAccount: "Crear cuenta y conectar con este taller",
    password: "Contraseña",
    confirmBooking: "Reservar cita",
    back: "Atrás",
    continue: "Continuar",
    loading: "Cargando…",
    booking: "Reservando…",
    successTitle: "¡Cita confirmada!",
    successBody: "Tu cita se ha reservado correctamente.",
    successEmail: "Recibirás un correo de confirmación con un enlace de cancelación.",
    salonNotFound: "Taller no encontrado. Comprueba el enlace.",
    errorGeneric: "Algo salió mal. Inténtalo de nuevo.",
    cancelTitle: "Cancelar cita",
    cancelConfirm: "Cancelar cita ahora",
    cancelSuccess: "Tu cita ha sido cancelada.",
    cancelAlready: "Esta cita ya estaba cancelada.",
    cancelInvalid: "El enlace de cancelación no es válido o ha caducado.",
    cancelTooLate: "Ya no es posible cancelar en este momento.",
    poweredBy: "Reserva a través de",
    duration: "Duración",
    minutes: "min",
    required: "Obligatorio",
    invalidEmail: "Correo no válido",
    passwordMin: "Al menos 10 caracteres, mayúscula, minúscula y un número",
    passwordTooWeak: "Elige una contraseña más fuerte (mín. 10 caracteres, mayúscula/minúscula, dígito).",
    orderTitle: "Pedido",
    orderEmail: "Correo o usuario",
    orderEmailPrompt: "Introduce tu correo o nombre de usuario",
    orderEmailHint: "Debe coincidir con el correo o usuario del pedido.",
    orderView: "Ver pedido",
    orderAccessDenied: "Código o correo/usuario no válido.",
    orderStatus: "Estado",
    orderItems: "Líneas",
    orderTotal: "Total",
    orderNote: "Nota",
    orderPickupScheduled: "Cita de recogida",
    orderSchedulePickup: "Programar recogida",
    orderPickupSuccessTitle: "¡Recogida confirmada!",
    orderPickupSuccessBody: "Tu cita de recogida se ha reservado correctamente.",
    orderConfirmPickup: "Reservar recogida",
    orderDropoffScheduled: "Cita de entrega",
    orderScheduleDropoff: "Programar entrega",
    orderRescheduleDropoff: "Cambiar entrega",
    orderCancelDropoff: "Cancelar entrega",
    orderConfirmDropoff: "Reservar entrega",
    orderDropoffSuccessTitle: "¡Entrega confirmada!",
    orderDropoffSuccessBody: "Tu cita de entrega se ha reservado correctamente.",
    orderDropoffCanceled: "Cita de entrega cancelada.",
    orderInquiries: "Consultas",
    orderInquiryHint: "Responde al taller…",
    orderInquiryAnswer: "Enviar respuesta",
    orderInquirySent: "Respuesta enviada.",
    orderInquiryStaff: "Taller",
    orderInquiryCustomer: "Tú",
    phaseReceived: "Recibido",
    phaseQuote: "Presupuesto",
    phaseInProgress: "En curso",
    phaseReady: "Listo para recoger",
    phaseDone: "Recogido",
    orderCustomerPhotosNotes: "Tus fotos y notas",
    orderCustomerAddPhoto: "Añadir foto",
    orderCustomerAddNote: "Añadir nota",
    orderCustomerNoteHint: "Describe el problema o añade detalles para el taller…",
    orderCustomerNotes: "Tus notas",
    orderCustomerPhotos: "Tus fotos",
    orderCustomerNoteAdded: "Nota añadida",
    orderCustomerPhotoAdded: "Foto añadida",
    orderUploading: "Subiendo…",
    rrTitle: "Solicitud de reparación",
    rrStepObject: "Objeto",
    rrStepDetails: "Detalles",
    rrStepContact: "Contacto",
    rrStepDropoff: "Entrega",
    rrStepServices: "Servicios",
    rrStepRepairDay: "Día de reparación",
    rrStepReview: "Revisar",
    rrPickServices: "Elige productos de servicio",
    rrPickServicesHint: "Elige una o más ofertas.",
    rrPricesExcludeParts: "Precios sin materiales ni piezas.",
    rrUncategorized: "Sin categoría",
    rrPickRepairDay: "Elige un día de reparación",
    rrNoCapacityDays: "No hay un día libre en las próximas semanas.",
    rrDropoffChoice: "¿Cuándo quieres entregarlo?",
    rrDropoffHintTitle: "Por favor, entrega",
    rrDropoffHintBody: "Entrega tu pieza / vehículo el {date} entre las {from} y las {to}.",
    rrDropoffDayBeforeChoice: "La víspera, {date}, {from}–{to}",
    rrDropoffSameDayChoice: "El día de reparación, {date}, {from}–{to}",
    rrSelectedServices: "Servicios elegidos",
    rrObjectHeading: "¿De qué objeto se trata?",
    rrObjectPreview: "Vista previa",
    rrDetailsHeading: "¿Qué hay que reparar?",
    rrDescription: "Descripción (opcional)",
    rrDescriptionHint: "Describe el daño o el problema con el mayor detalle posible.",
    rrPhotos: "Fotos (opcional)",
    rrPhotosHint: "p. ej. fotos del objeto, del daño o del permiso de circulación",
    rrAddressSearch: "Buscar dirección",
    rrAddressSearchHint: "Introduce calle, código postal o localidad",
    rrAddressNotFound: "No se ha encontrado ninguna dirección.",
    rrAddPhoto: "Añadir foto",
    rrRemovePhoto: "Quitar",
    rrContactHeading: "Tus datos de contacto",
    rrFirstName: "Nombre",
    rrLastName: "Apellidos",
    rrEmailRequired: "Correo",
    rrPhoneRequired: "Teléfono",
    rrStreet: "Calle",
    rrPostalCode: "CP",
    rrCity: "Ciudad",
    rrAddressOptional: "Dirección (opcional)",
    rrInvalidPhone: "Teléfono no válido",
    rrDropoffHeading: "Elige una hora de entrega",
    rrDropoffHint: "Elige cuándo llevarás el objeto al taller.",
    rrDropoffSkip: "Programar más tarde",
    rrDropoffSelected: "Hora de entrega seleccionada",
    rrDropoffRequired: "Elige una hora de entrega.",
    rrReviewHeading: "Resumen",
    rrSubmit: "Enviar solicitud",
    rrSubmitting: "Enviando…",
    rrSuccessTitle: "¡Solicitud recibida!",
    rrSuccessBody: "Tu solicitud de reparación se ha enviado.",
    rrSuccessEmail: "Recibirás un correo de confirmación.",
    rrOrderNumber: "Número de solicitud",
    rrDownloadApp: "Descargar la app Werkstate",
    rrDownloadAppHint: "Sigue el estado y recibe avisos — mejor en la app.",
    rrUnavailable: "Las solicitudes de reparación no están disponibles en este taller.",
    rrPoweredBy: "Solicitud a través de",
    legalNavLabel: "Legal",
    legalPrivacy: "Privacidad",
    legalTerms: "Términos",
    legalImprint: "Aviso legal",
    consentPrefix: "Acepto la ",
    consentPrivacyLink: "política de privacidad",
    consentAnd: " y los ",
    consentTermsLink: "términos",
    consentRequired: "Acepta la política de privacidad y los términos.",
  },
  fr: {
    ...enMessages,
    bookAppointment: "Réserver un rendez-vous",
    stepService: "Prestation",
    stepStaff: "Employé",
    stepTime: "Heure",
    stepContact: "Contact",
    chooseService: "Choisissez une prestation",
    chooseStaff: "Choisissez un employé",
    noPreference: "Sans préférence",
    chooseDay: "Choisissez un jour",
    chooseSlot: "Choisissez une heure",
    noSlots: "Aucun créneau disponible ce jour-là.",
    yourDetails: "Vos coordonnées",
    name: "Nom",
    phone: "Téléphone (facultatif)",
    email: "E-mail (facultatif)",
    emailHint: "Pour l’e-mail de confirmation avec lien d’annulation",
    note: "Remarque (facultatif)",
    createAccount: "Créer un compte et se connecter à cet atelier",
    password: "Mot de passe",
    confirmBooking: "Réserver le rendez-vous",
    back: "Retour",
    continue: "Continuer",
    loading: "Chargement…",
    booking: "Réservation…",
    successTitle: "Rendez-vous confirmé !",
    successBody: "Votre rendez-vous a bien été réservé.",
    successEmail: "Vous recevrez un e-mail de confirmation avec un lien d’annulation.",
    salonNotFound: "Atelier introuvable. Vérifiez le lien.",
    errorGeneric: "Une erreur est survenue. Veuillez réessayer.",
    cancelTitle: "Annuler le rendez-vous",
    cancelConfirm: "Annuler le rendez-vous maintenant",
    cancelSuccess: "Votre rendez-vous a été annulé.",
    cancelAlready: "Ce rendez-vous était déjà annulé.",
    cancelInvalid: "Le lien d’annulation est invalide ou expiré.",
    cancelTooLate: "L’annulation n’est plus possible à ce moment.",
    poweredBy: "Réservation via",
    duration: "Durée",
    minutes: "min",
    required: "Obligatoire",
    invalidEmail: "Adresse e-mail invalide",
    passwordMin: "Au moins 10 caractères, majuscule, minuscule et un chiffre",
    passwordTooWeak: "Choisissez un mot de passe plus fort (min. 10 caractères, majuscule/minuscule, chiffre).",
    orderTitle: "Commande",
    orderEmail: "E-mail ou nom d’utilisateur",
    orderEmailPrompt: "Saisissez votre e-mail ou nom d’utilisateur",
    orderEmailHint: "Doit correspondre à l’e-mail ou au nom d’utilisateur de la commande.",
    orderView: "Voir la commande",
    orderAccessDenied: "Code ou e-mail/nom d’utilisateur invalide.",
    orderStatus: "Statut",
    orderItems: "Lignes",
    orderTotal: "Total",
    orderNote: "Remarque",
    orderPickupScheduled: "Rendez-vous de retrait",
    orderSchedulePickup: "Planifier le retrait",
    orderPickupSuccessTitle: "Retrait confirmé !",
    orderPickupSuccessBody: "Votre rendez-vous de retrait a bien été réservé.",
    orderConfirmPickup: "Réserver le retrait",
    orderDropoffScheduled: "Rendez-vous de dépôt",
    orderScheduleDropoff: "Planifier le dépôt",
    orderRescheduleDropoff: "Modifier le dépôt",
    orderCancelDropoff: "Annuler le dépôt",
    orderConfirmDropoff: "Réserver le dépôt",
    orderDropoffSuccessTitle: "Dépôt confirmé !",
    orderDropoffSuccessBody: "Votre rendez-vous de dépôt a bien été réservé.",
    orderDropoffCanceled: "Rendez-vous de dépôt annulé.",
    orderInquiries: "Questions",
    orderInquiryHint: "Répondez à l’atelier…",
    orderInquiryAnswer: "Envoyer la réponse",
    orderInquirySent: "Réponse envoyée.",
    orderInquiryStaff: "Atelier",
    orderInquiryCustomer: "Vous",
    phaseReceived: "Reçu",
    phaseQuote: "Devis",
    phaseInProgress: "En cours",
    phaseReady: "Prêt à retirer",
    phaseDone: "Retiré",
    orderCustomerPhotosNotes: "Vos photos et notes",
    orderCustomerAddPhoto: "Ajouter une photo",
    orderCustomerAddNote: "Ajouter une note",
    orderCustomerNoteHint: "Décrivez le problème ou ajoutez des détails pour l’atelier…",
    orderCustomerNotes: "Vos notes",
    orderCustomerPhotos: "Vos photos",
    orderCustomerNoteAdded: "Note ajoutée",
    orderCustomerPhotoAdded: "Photo ajoutée",
    orderUploading: "Téléversement…",
    rrTitle: "Demande de réparation",
    rrStepObject: "Objet",
    rrStepDetails: "Détails",
    rrStepContact: "Contact",
    rrStepDropoff: "Dépôt",
    rrStepServices: "Services",
    rrStepRepairDay: "Jour de réparation",
    rrStepReview: "Vérifier",
    rrPickServices: "Choisir des produits de service",
    rrPickServicesHint: "Choisissez une ou plusieurs offres.",
    rrPricesExcludeParts: "Prix hors matériaux et pièces.",
    rrUncategorized: "Sans catégorie",
    rrPickRepairDay: "Choisissez un jour de réparation",
    rrNoCapacityDays: "Aucun jour correspondant n’est libre dans les prochaines semaines.",
    rrDropoffChoice: "Quand souhaitez-vous déposer ?",
    rrDropoffHintTitle: "Veuillez déposer",
    rrDropoffHintBody: "Déposez votre pièce / véhicule le {date} entre {from} et {to}.",
    rrDropoffDayBeforeChoice: "La veille, {date}, {from}–{to}",
    rrDropoffSameDayChoice: "Le jour de réparation, {date}, {from}–{to}",
    rrSelectedServices: "Services choisis",
    rrObjectHeading: "De quel objet s’agit-il ?",
    rrObjectPreview: "Aperçu",
    rrDetailsHeading: "Que faut-il réparer ?",
    rrDescription: "Description (facultatif)",
    rrDescriptionHint: "Décrivez le dégât ou le problème aussi précisément que possible.",
    rrPhotos: "Photos (facultatif)",
    rrPhotosHint: "p. ex. photos de l’objet, du dégât ou de la carte grise",
    rrAddressSearch: "Rechercher une adresse",
    rrAddressSearchHint: "Saisissez rue, code postal ou ville",
    rrAddressNotFound: "Aucune adresse trouvée.",
    rrAddPhoto: "Ajouter une photo",
    rrRemovePhoto: "Retirer",
    rrContactHeading: "Vos coordonnées",
    rrFirstName: "Prénom",
    rrLastName: "Nom",
    rrEmailRequired: "E-mail",
    rrPhoneRequired: "Téléphone",
    rrStreet: "Rue",
    rrPostalCode: "Code postal",
    rrCity: "Ville",
    rrAddressOptional: "Adresse (facultatif)",
    rrInvalidPhone: "Numéro de téléphone invalide",
    rrDropoffHeading: "Choisissez une heure de dépôt",
    rrDropoffHint: "Choisissez quand vous apporterez l’objet à l’atelier.",
    rrDropoffSkip: "Planifier plus tard",
    rrDropoffSelected: "Heure de dépôt choisie",
    rrDropoffRequired: "Veuillez choisir une heure de dépôt.",
    rrReviewHeading: "Récapitulatif",
    rrSubmit: "Envoyer la demande",
    rrSubmitting: "Envoi…",
    rrSuccessTitle: "Demande reçue !",
    rrSuccessBody: "Votre demande de réparation a été transmise.",
    rrSuccessEmail: "Vous recevrez un e-mail de confirmation.",
    rrOrderNumber: "Numéro de demande",
    rrDownloadApp: "Télécharger l’app Werkstate",
    rrDownloadAppHint: "Suivez le statut et recevez des notifications — de préférence dans l’app.",
    rrUnavailable: "Les demandes de réparation ne sont pas disponibles pour cet atelier.",
    rrPoweredBy: "Demande via",
    legalNavLabel: "Mentions",
    legalPrivacy: "Confidentialité",
    legalTerms: "CGU",
    legalImprint: "Mentions légales",
    consentPrefix: "J’accepte la ",
    consentPrivacyLink: "politique de confidentialité",
    consentAnd: " et les ",
    consentTermsLink: "CGU",
    consentRequired: "Veuillez accepter la politique de confidentialité et les CGU.",
  },
} as const;

export type MessageKey = keyof typeof deMessages;

export function detectLocale(): Locale {
  const lang = navigator.language.toLowerCase();
  if (lang.startsWith("de")) return "de";
  if (lang.startsWith("es")) return "es";
  if (lang.startsWith("fr")) return "fr";
  return "en";
}

export function t(locale: Locale, key: MessageKey): string {
  return messages[locale][key];
}
